import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Toast from '../../commons/Toast';
import {clearNotice} from '../../actions/productFirstActions';

const NoticeToast = () => {
  const dispatch = useDispatch();
  const notice = useSelector(state => state.productFirst.notice);

  return (
    <Toast
      visible={!!notice}
      message={notice}
      persistent
      noModal
      onHide={() => dispatch(clearNotice())}
      onClose={() => dispatch(clearNotice())}
      colors={['#b00020', '#e53935']}
      textColor={'#fff'}
    />
  );
};

export default NoticeToast;
